import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import cn from "classnames";
import styles from "./StudentCreate.module.sass";
import { Link } from "react-router-dom";
import Icon from "../../components/Icon";
import Card from "../../components/Card";
import TextInput from "../../components/TextInput";
import StudentSearchBarMultiple from "./StudentSearchBarMultiple";


// Services
import { createSessionGroup } from "../../services/sessionGroup.service.js";
import { useAuth } from "../../contexts/AuthContext";
import { showSuccess, showError } from "../../services/toast.service";

const SessionGroupsCreate = () => {
  const navigate = useNavigate();
  const { getPartnerId } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [sessionGroupData, setSessionGroupData] = useState({
    title: '',
    students_id: []
  });


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSessionGroupData((prev) => ({ ...prev, [name]: value }));
  };

  const handleStudentsChange = (e) => {
    const { value } = e.target;
    setSessionGroupData((prev) => ({ ...prev, students_id: value }));
  };

  // Validation des champs requis
  const validateForm = () => {
    const errors = [];
    
    if (!sessionGroupData.title?.trim()) {
      errors.push('Le titre du groupe est requis');
    }
    
    if (!sessionGroupData.students_id || sessionGroupData.students_id.length === 0) {
      errors.push('Au moins un étudiant doit être sélectionné');
    }
    
    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    // Validation avant soumission
    const validationErrors = validateForm();
    if (validationErrors.length > 0) {
      const errorMessage = 'Veuillez corriger les erreurs suivantes:\n' + validationErrors.join('\n');
      showError(errorMessage);
      setError(errorMessage);
      setLoading(false);
      return;
    }

    try {
      const dataToSend = {
        title: sessionGroupData.title,
        partner_id: getPartnerId(),
        students_id: sessionGroupData.students_id
      };
      
      
      await createSessionGroup(dataToSend);
      showSuccess("Groupe de session créé avec succès!");
      navigate("/admin/session-groups/");
    } catch (err) {
      const errorMessage =
        "Impossible de créer le groupe de session: " +
        (err.message || "Veuillez vérifier les informations saisies.");
      showError(errorMessage);
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  // Vérifier si le formulaire est valide pour activer/désactiver le bouton
  const isFormValid = () => {
    return validateForm().length === 0;
  };

  return (
    <>
      <div className={styles.container}>
        <Link className={cn("button-white", styles.button)} to="/admin/session-groups/">
          <Icon name="arrow-left" />
          Retour
        </Link>

        <div className={styles.background}>
          <img src="/images/content/bg-shop.jpg" alt="Background" />
        </div>

        <div className={styles.formContainer}>
          {error && <div className={styles.error}>{error}</div>}
          
          <Card 
            className={styles.card}
            title="Créer un groupe de session"
            classTitle={cn("title-blue", styles.title)}
          >
            <form onSubmit={handleSubmit}>
              <div className={styles.row}>
                <div className={styles.col}>
                  <TextInput
                    className={styles.field}
                    label="Titre du groupe"
                    name="title"
                    type="text"
                    placeholder="Entrez le titre du groupe"
                    value={sessionGroupData.title}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>
              
              <div className={styles.row}>
                <div className={styles.col}>
                  <StudentSearchBarMultiple
                    className={styles.field}
                    label="Étudiants"
                    placeholder="Recherchez et sélectionnez les étudiants pour ce groupe"
                    value={sessionGroupData.students_id}
                    onSelectionChange={handleStudentsChange}
                    required
                    onSubmit={handleSubmit}
                    loading={loading}
                    isFormValid={isFormValid}
                    submitButtonText="Créer le groupe"
                  />
                </div>
              </div>
            
            </form>
          </Card>
        </div>
      </div>
    </>
  );
};

export default SessionGroupsCreate;
